export default __webpack_public_path__ + "static/monetka-c32d0f8175a256fa6e289007c9fbd4ff.webp";